import { render, staticRenderFns } from "./CreateEditClientForm.vue?vue&type=template&id=52dd4a16"
import script from "./CreateEditClientForm.vue?vue&type=script&lang=js"
export * from "./CreateEditClientForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports